// src/router/index.js
import {createRouter, createWebHistory} from 'vue-router'
import LoginPage from '@/components/LoginPage.vue'
import ForgetPasswordPage from '@/components/ForgetPasswordPage.vue'
import MainPage from "@/components/MainPage";
import CompanyPage from "@/components/main/CompanyPage";
import AccountPage from "@/components/main/AccountPage";
import EventPage from "@/components/main/EventPage";
import DevicePage from "@/components/main/DevicePage";
import ReportPage from "@/components/main/ReportPage";
import ProfilePage from "@/components/main/ProfilePage";
import CompanyAddPage from "@/components/main/CompanyAddPage";
import ProfileEditPage from "@/components/main/ProfileEditPage";
import CompanyEditPage from "@/components/main/CompanyEditPage";
import AccountAddPage from "@/components/main/AccountAddPage";
import AccountEditPage from "@/components/main/AccountEditPage";
import AccountViewPage from "@/components/main/AccountViewPage";
import CompanyViewPage from "@/components/main/CompanyViewPage";
import TerOfUsePage from "@/components/main/TermOfUsePage";
import PrivacyPolicyPage from "@/components/main/PrivacyPolicyPage";
import CleaningLogPage from "@/components/main/CleaningLogPage";
import CleaningLogAddPage from "@/components/main/CleaningLogAddPage";
import CleaningLogEditPage from "@/components/main/CleaningLogEditPage";
import CleaningLogViewPage from "@/components/main/CleaningLogViewPage";
import LoginLogDetailPage from "@/components/main/LoginLogDetailPage.vue";

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: LoginPage
    },
    {
        path: '/forget-password',
        name: 'ForgetPassword',
        component: ForgetPasswordPage
    },
    {
        path: '/',
        component: MainPage,
        meta: {requiresAuth: true},
        children: [
            {path: 'company', component: CompanyPage},
            {path: 'company/add', component: CompanyAddPage},
            {path: 'company/view/:id', name: 'CompanyView', component: CompanyViewPage},
            {path: 'company/edit/:id', name: 'CompanyEdit', component: CompanyEditPage},
            {path: 'account', component: AccountPage},
            {path: 'account/add', component: AccountAddPage},
            {path: 'account/view/:id', name: 'AccountView', component: AccountViewPage},
            {path: 'account/edit/:id', name: 'AccountEdit', component: AccountEditPage},
            {path: 'event', component: EventPage},
            {path: 'cleaning-log', component: CleaningLogPage},
            {path: 'cleaning-log/add', name: 'CleaningLogAdd', component: CleaningLogAddPage},
            {path: 'cleaning-log/view/:id', name: 'CleaningLogView', component: CleaningLogViewPage},
            {path: 'cleaning-log/edit/:id', name: 'CleaningLogEdit', component: CleaningLogEditPage},
            {path: 'device', component: DevicePage},
            {path: 'report', component: ReportPage},
            {path: 'profile', component: ProfilePage},
            {path: 'profile/edit', component: ProfileEditPage},
            {path: 'login-log-detail/:logId', name: 'LoginLogDetail', component: LoginLogDetailPage},
        ]
    },
    {
        path: '/term-of-use',
        name: 'termOfUse',
        component: TerOfUsePage
    },
    {
        path: '/privacy-policy',
        name: 'privacyPolicy',
        component: PrivacyPolicyPage
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const userData = localStorage.getItem('user');

    if (to.meta.requiresAuth && !userData) {
        // 如果需要驗證但未登入，導向登入頁面
        next('/login');
    } else {
        next(); // 允許進入路由
    }
});

export default router
